
import React, {useState} from "react";
import "./Snapmint.css";
import './Hrone.css';
import Hrone1 from '../../images/casestudies/Hrone1.webp';
import a from '../../images/casestudies/snapinv1.webp';
import b from '../../images/casestudies/Insitor.webp';

import c from '../../images/casestudies/Hrone2.webp';


const FlipCard = ({ frontText, backContent }) => {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <p className="text-white ">{frontText}</p>
        </div>
        <div className="flip-card-back">
          {backContent}
        </div>
      </div>
    </div>
  );
};
const SnapmintPage = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="container my-5">
      <div className="roundBorder">
      
      <h2 className="titleServ">
      HROne – Fastest growing SAAS company outperforming all the SAAS wish list metrics
              </h2>
              <div className="lineServ mt-40"></div>
      <div className=" mt-40">
      <div className="Hrone-container mt-5">
  <div className="Hrone-card1">
    <img className="Hrone-timeline-caseImg" src={ Hrone1} />
  </div>

  <div className={isOpen ? "hrone-investor-section" : "hrone-investor-section2 "}>
    <div className="investors-card">
      <div className="investors-header">
        <span className={isOpen ? "title-open" : "title-closed "}>INVESTORS</span>
        <button className={isOpen ? "title-open toggle-button" : "title-closed toggle-button"} onClick={toggleSection}>
          {isOpen ? "-" : "+"}
        </button>
      </div>
      {isOpen && (
        <div className="investors-content">
          <a href="https://prudentim.com/">
                    <img src={a} alt="Prudential" />
                    </a>
                    <a href="https://www.insitorpartners.com/">
                    <img src={b} alt="Kae Capital" />
                    </a>

          
                    
                    
        </div>
      )}
    </div>
  </div>
</div>

                  </div>

                 
                  <h2 className="titleServ mb-5 mt-5">
                  When there was no wave!
              </h2>
              <div className="lineServ mt-40"></div>
    <div className="card-container">
      <FlipCard
        frontText="2020 - No Growth funding flowing into HRMS"
        backContent={
          <div className="flip-back-card">
            <div className="hrone-list-1">
            <ul className="">
                <li>A massive Indian labour-intensive market</li>
                <li>Complete Horizontal Play</li>
                <li>No large player, except Darwin Box</li>
            </ul>

            <h3>MARKET THESIS</h3>

            <ul className="">
                <li>A competitive market</li>
                <li>Commoditized Offerings</li>
                <li>India-focused SaaS won’t work</li>
            </ul>
            </div>

          </div>
        }
      />
      <FlipCard
        frontText="Radix Key Insight"
        backContent={
                    <div className="hrone-list-2">
            <ul >
  <li>HRMS is a B2B segment, but products <strong>need to be built with B2C expectations</strong></li>
  <li><strong>Secret Sauce!</strong> - Simplified, easy-to-use UI and amazing user experience</li>
  <li>A simple tool, built for the masses at the right price point, can<strong>unlock the massive Indian market</strong> </li>
  <li><strong>Unlocking massive cross-selling opportunities</strong></li>
</ul>
       </div>
        }
      />
      
    </div>

       
    <h2 className="titleServ snap-title2">
    1 Platform, 127 HR processes. As comprehensive as it gets
              </h2>
              <div className="lineServ mt-40"></div>
      <div className="row my-4">
        <div className="col-md-6">
          <div className="">
            <img src={c} alt="Snapmint" />
            
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-box">
            <h4 className="titleServ titleServ2">HROne Today</h4>
            <div style={{"marginInlineStart":"160px"}} className="lineServ "></div>
            <p  className=" text-black fw-bold titleServ2">4x </p>
              <p className=" text-black">Growth in ARR </p>
            <p  className=" text-black fw-bold titleServ2">5x</p>
            <p className=" text-black"> Growth in customers</p>
            <p className=" text-black fw-bold titleServ2">A Minicorn!</p>
          </div>
        </div>
      </div>
      <div className="text-center my-5">
          <a href="/neewee">
            <button className="btnArrow">
              <i className="fa-solid fa-arrow-left"></i> Medkart
            </button>
          </a>
          &nbsp;&nbsp;
          <a href="/sukhhi">
            <button className="btnArrow">
              Freshee <i className="fa-solid fa-arrow-right"></i>
            </button>
          </a>
        </div>
        </div>
    </div>
  );
};

export default SnapmintPage;

